import { ReactNode } from 'react';
import { components } from '@api/play-account/generated';

import { PlayerGamesList } from '@features/user/ui/PlayerGamesList/PlayerGamesList';

type Props = {
  games: components['schemas']['UserGameHistoryItemDto'][];
  onGameClick: (game: components['schemas']['UserGameHistoryItemDto']) => void;
  renderShieldQuickPeek?: (userId: string) => ReactNode;
};
export function SomePlayerGamesList({ games, onGameClick, renderShieldQuickPeek }: Props) {
  return (
    <PlayerGamesList
      games={games}
      onGameClick={onGameClick}
      renderShieldQuickPeek={renderShieldQuickPeek}
    />
  );
}
